import {forwardRef, useState} from "react";

import guide_en from "@images/home/suit/guide_en.png";
import guide_ru from "@images/home/suit/guide_ru.png";
import hcp_en from "@images/home/suit/hcp_en.png";
import hcp_ru from "@images/home/suit/hcp_ru.png";
import managers_en from "@images/home/suit/managers_en.png";
import managers_ru from "@images/home/suit/managers_ru.png";
import redefining_en from "@images/home/suit/redefining_en.png";
import redefining_ru from "@images/home/suit/redefining_ru.png";
import rotateBackImage from "@images/home/suit/rotate-back.png";
import rotateFrontImage from "@images/home/suit/rotate-front.png";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {motion} from "framer-motion";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

const itemAnimation = {
  hidden: {opacity: 0},
  visible: (custom) => ({
    opacity: 1,
    transition: {
      delay: custom * 0.3,
    },
  }),
};

const RotateCard = forwardRef((props, ref) => {
  const {title, subtitle, desc, image} = props;
  const [rotate, setRotate] = useState(false);
  const {isMobile} = useSelector((state) => state.common.settings);

  const handleClickCard = () => {
    setRotate(!rotate);
  };

  return (
    <li
      ref={ref}
      className={styles.rotate_card_wrap}
    >
      <div
        onClick={handleClickCard}
        style={{
          transform: rotate ? "rotateY(-180deg)" : "rotateY(0deg)",
        }}
        className={styles.rotate_card}
      >
        <div className={styles.rotate_card_front}>
          <h3>{title}</h3>

          <p>{subtitle}</p>

          <div className={styles.rotate_card_image}>
            <img
              src={image}
              alt={"image"}
            />
          </div>

          <div className={styles.rotate_card_icon}>
            <img
              src={!isMobile ? rotateFrontImage : rotateBackImage}
              alt={"rotate-front"}
            />
          </div>
        </div>

        <div className={styles.rotate_card_back}>
          <RootDesc>{desc}</RootDesc>

          {!isMobile && (
            <div className={styles.rotate_card_icon}>
              <img
                src={rotateBackImage}
                alt={"rotate-back"}
              />
            </div>
          )}
        </div>
      </div>
    </li>
  );
});

export const MRotateCard = motion(RotateCard);

export const RotateCards = () => {
  const {t} = useTranslation();
  const {language, isMobile} = useSelector((state) => state.common.settings);

  const rotateCards = [
    {
      id: 0,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.rotate.title_1"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.rotate.subtitle_1"),
          }}
        />
      ),
      desc: (
        <article
          dangerouslySetInnerHTML={{
            __html: t("page.suit.rotate.desc_1"),
          }}
        />
      ),
      image: language === "en" ? redefining_en : redefining_ru,
    },
    {
      id: 1,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.rotate.title_2"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.rotate.subtitle_2"),
          }}
        />
      ),
      desc: (
        <article
          dangerouslySetInnerHTML={{
            __html: t("page.suit.rotate.desc_2"),
          }}
        />
      ),
      image: language === "en" ? guide_en : guide_ru,
    },
    {
      id: 2,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.rotate.title_3"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.rotate.subtitle_3"),
          }}
        />
      ),
      desc: (
        <article
          dangerouslySetInnerHTML={{
            __html: t("page.suit.rotate.desc_3"),
          }}
        />
      ),
      image: language === "en" ? managers_en : managers_ru,
    },
    {
      id: 3,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.rotate.title_4"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.rotate.subtitle_4"),
          }}
        />
      ),
      desc: (
        <article
          dangerouslySetInnerHTML={{
            __html: t("page.suit.rotate.desc_4"),
          }}
        />
      ),
      image: language === "en" ? hcp_en : hcp_ru,
    },
  ];

  return (
    <motion.ul
      initial={"hidden"}
      whileInView={"visible"}
      viewport={{amount: 0.3, once: true}}
      className={styles.rotate_cards}
    >
      {rotateCards &&
        rotateCards.length > 0 &&
        rotateCards.map((card) => (
          <MRotateCard
            custom={card.id + 1}
            variants={!isMobile ? itemAnimation : undefined}
            key={card.id}
            title={card.title}
            subtitle={card.subtitle}
            desc={card.desc}
            image={card.image}
          />
        ))}
    </motion.ul>
  );
};
